export function formatPurchaserKey(value: string): string {
  return value.trim().replaceAll(/\s+/g, "-").toUpperCase();
}

export const PURCHASER_KEY_ALREADY_EXISTS_MESSAGE =
  "This Purchaser Key already exists.";

function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === "string") {
    return error;
  }
  return "";
}

export function isPurchaserKeyDuplicateError(error: unknown): boolean {
  const normalized = getErrorMessage(error).toLowerCase();
  return (
    normalized.includes("duplicate") || normalized.includes("already exists")
  );
}

export function getPurchaserKeyFieldError(error: unknown): string | null {
  if (!isPurchaserKeyDuplicateError(error)) {
    return null;
  }
  return PURCHASER_KEY_ALREADY_EXISTS_MESSAGE;
}
